import './user-management.scss';
import { Auth } from 'aws-amplify';
import { useCallback, useState } from 'react';
import PageHeader from '../../shared/blocks/page-header/page-header';
import Loader from '../../shared/blocks/loader/loader';
import { isValidEmail } from '../../../utilities/utils';

const UserManagement = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const onResetPassword = useCallback(async () => {
    if (email && !isLoading) {
      setIsSubmitted(false);
      setError('');

      if (!isValidEmail(email)) {
        setError('Email is not valid.');
        return;
      }

      setIsLoading(true);

      const result = await Auth.forgotPassword(email);

      if (result && result.CodeDeliveryDetails) {
        setIsSubmitted(true);
      } else {
        setError('');
      }

      setIsLoading(false);
    }
  }, [email, isLoading]);

  return (
    <div className="page-view user-management-view">
      <PageHeader pageTitle="Reset User Password" />

      <div className="add-email-control">
        <input className="input" placeholder="Email Address" value={email} onChange={(e) => setEmail(e.target.value)} />
        <button type="button" className="button" onClick={onResetPassword}>
          {isLoading ? <Loader /> : 'Reset Password'}
        </button>
      </div>

      <div className={`ff-graphik fw-normal fs-p2 m-t-12 ${error ? 'error warn' : ''}`}>
        {isSubmitted ? 'Password reset link sent to the email.' : ''}
        {error ?? ''}
      </div>
    </div>
  );
};

export default UserManagement;
